const set = ({ data, loadingState, oldData }) => {
  // Only treat the payload as a paginated list when `items` is an actual array.
  // Object responses that happen to carry an `items` field (e.g. the dashboard
  // summary's `items: { total, new }`) must be stored under `.data` instead of
  // being mistaken for a list, which would drop the rest of the payload.
  if (Array.isArray(data?.items)) {
    return {
      ...oldData,
      ...data,
      items: data?.items,
      totalItems: data?.totalItems,
      totalPages: data?.totalPages,
      page: data?.page,
      loading: false,
    };
  } else {
    if (!!loadingState) {
      return {
        ...oldData,
        data: data,
        loading: false,
      };
    } else {
      return data;
    }
  }
};

export default set;
